<template>
  <div>
    <AppNavigationTop :navigationInfo="AppNavigationTopInfo"/>
    <v-container fluid grid-list-xl>
      <v-layout class="mt-1 mb-1">
        <v-flex xs12 sm12 md11 lg9 xl6 offset-md1 offset-lg1 offset-xl3>
          <div :class="ui.textTitle">
            User Activity
          </div>
        </v-flex>
      </v-layout>
      <div>
        <v-layout class="mt-1 mb-1">
          <v-flex xs12 sm11 md9 xl6 offset-sm0 offset-md1 offset-xl3>
            <UserToolbarSystem/>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <v-layout class="mt-1 mb-1">
          <v-flex xs12 sm11 md9 xl6 offset-sm0 offset-md1 offset-xl3>
            <UserToolbarOpen/>
          </v-flex>
        </v-layout>
      </div>
      <v-layout row v-if="this.getSearchResults !== null" class="mt-1 mb-1">
        <v-flex xs12 sm11 md9 xl6 offset-sm0 offset-md1 offset-xl3>
          <DocumentLogListSimple/>
        </v-flex>
      </v-layout>
      <v-layout row v-else class="mt-1 mb-1">
        <v-flex xs12 sm11 md9 xl6 offset-sm0 offset-md1 offset-xl3>
          <v-toolbar :color="ui.cardColor">
            <v-toolbar-title :class="ui.textSubheadingBold">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> reorder</v-icon>
                </v-avatar>
                User Activity Log is Empty
              </v-chip>
            </v-toolbar-title>
          </v-toolbar>
        </v-flex>
      </v-layout>
      <v-layout row mb-4>
      </v-layout>
      <v-layout row mb-4>
      </v-layout>
    </v-container>
    <AppNavigationBottom/>
</div>
</template>

<script>
import AppNavigationBottom from "@/frame/navigation/components/AppNavigationBottom";
import AppNavigationTop from "@/frame/navigation/components/AppNavigationTop";
import UserToolbarSystem from "@/frame/toolbar/components/UserToolbarSystem";
import UserToolbarOpen from "@/frame/toolbar/components/UserToolbarOpen";
import DocumentLogListSimple from "@/document/log/components/DocumentLogListSimple";
import currentPage from "@/frame/pages/mixins/currentPage.js";
import announcements from "@/frame/messages/mixins/announcements.js";
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import userFunctions from "@/data/functions/mixins/userFunctions.js";

export default {
  components: {
    AppNavigationBottom,
    AppNavigationTop,
    UserToolbarSystem,
    DocumentLogListSimple,
    UserToolbarOpen
  },
  // eslint-disable-next-line
  mixins: [
    currentPage,
    apptheme,
    announcements,
    userFunctions
  ],
  created() {
    this.$store.dispatch("changeCompanyDID", this.getUser.pref.select.cdid);
    this.$store.dispatch("changeFacilityDID", this.getUser.pref.select.fdid);
  },
  data() {
    return {
      currentPagePath: "/usermanagement"
    };
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getUser",
      "getCurrentPage",
      "getPreviousPage",
      "getSearchResults",
      "getDocumentLogUserUnreadCounter"
    ]),
    AppNavigationTopInfo() {
      let obj = {
        title: "User Dash",
        titleColour: "wplblue0--text",
        btns: [
          {
            title: "user",
            icon: "person",
            link: "/userdash"
          },
          {
            title: "sign out",
            icon: "person_outline",
            link: "/signout"
          }
        ]
      };
      if (this.getUser.pref.select.fauth !== null) {
        obj.title = this.getUser.pref.select.fname;
      }
      obj.title = this.getUser.basic.title;
      return obj;
    }
  },
  beforeMount() {
    this.$store.dispatch("changePreviousPage", this.getCurrentPage);
    this.$store.dispatch("changeCurrentPage", this.currentPagePath);
    // DEFINE type of Document Log for future updates Read/Undear updates
    this.$store.dispatch("changeDocumentLogTag", "U1");
    // GENERATE snackbar
    this.generateUserCountersMessage();
  }
};
</script>
